// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2VSwc","header":"Messages_header__16wwu"};